export default function SearchSuggestions({ 
  suggestions, 
  selectedSuggestion, 
  onSuggestionClick,
  searchTerm 
}) {
  // Labels para las categorías y badges de Medusa
  const getLabelForSuggestion = (suggestion) => {
    const labels = {
      // Categorías (handles de Medusa)
      'todo': 'Todo',
      'sueros': 'Sueros',
      'tonicos': 'Tónicos',
      'hidratantes': 'Hidratantes',
      'limpiadores': 'Limpiadores',
      'solares': 'Protección Solar',
      'tratamientos': 'Tratamientos',
      'correctivos': 'Correctivos',
      'exfoliantes': 'Exfoliantes',
      'kits': 'Kits',
      'sets': 'Sets',
      
      // Badges
      'launch': 'Lanzamiento',
      'essential': 'Esencial en tu rutina',
      'basic': 'Básico en tu rutina',
    };
    
    return labels[suggestion] || suggestion;
  };

  return (
    <div className="hidden md:block w-56 lg:w-[22rem] bg-[var(--phys-snow)] border-r border-[var(--phys-frost)] p-4 lg:p-6 overflow-y-auto flex-shrink-0">
      <h3 className="text-xs uppercase tracking-wider text-[#999] font-light mb-4">
        Filtrar por
      </h3>
      
      {suggestions.length === 0 && (
        <p className="text-sm text-[#999] font-light">
          Escribe para buscar productos
        </p>
      )}

      <ul className="space-y-1">
        {suggestions.map((suggestion) => (
          <li key={suggestion}>
            <button
              onClick={() => onSuggestionClick(suggestion)}
              className="text-left py-2 text-sm font-light transition-colors duration-200 group"
            >
              <span 
                className={`
                  relative inline-block
                  ${selectedSuggestion === suggestion
                    ? 'text-[#333] font-normal'
                    : 'text-[#666] group-hover:text-[#333]'
                  }
                  after:content-['']
                  after:absolute
                  after:bottom-0
                  after:left-0
                  after:h-[1px]
                  after:bg-[#333]
                  after:transition-all
                  after:duration-300
                  after:ease-out
                  ${selectedSuggestion === suggestion
                    ? 'after:w-full'
                    : 'after:w-0 group-hover:after:w-full'
                  }
                `}
              >
                {getLabelForSuggestion(suggestion)}
              </span>
            </button>
          </li>
        ))}
      </ul>

      {/* Clear Selection */}
      {selectedSuggestion && (
        <button
          onClick={() => onSuggestionClick(null)}
          className="
            mt-4 text-left py-2 text-xs
            text-[#999] hover:text-[#333]
            border-t border-[var(--phys-frost)]
            transition-colors
          "
        >
          ← Limpiar filtro
        </button>
      )}
    </div>
  );
}